import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { Input, Row, Col } from "antd";
import { FormItem } from "Components/form";

export default function Total({ form, total = 0, ...props }) {
  const { setValue } = form;
  useEffect(() => {
    setValue("allocationBasicScore", total);
  }, [total]);

  return (
    <Controller
      control={form.control}
      name="allocationBasicScore"
      as={<Input style={{ textAlign: "center" }} readOnly />}
    />
  );
}
